export enum UpgradeToGoldVariant {
  TalentSearch = 'talent-search',
  LaborMarket = 'labor-market',
  InterviewScheduling = 'interview-scheduling',
}

export type UpgradeToGoldModalProps = {
  isOpen: boolean;
  variant?: UpgradeToGoldVariant;
  hasRequestedGold?: boolean;
};

export type GoldUpgradeConfirmedModalProps = {
  isOpen: boolean;
};
